export enum PushMsgType {
  NONE = 'none',
  P2P = 'p2p:msg',
  GROUP = 'grp:msg'
}
